export enum SUPPORTED_WARRANTY_VARIANTS_ENUM {
    primary = "primary",
    secondary = "secondary",
}

export type SUPPORTED_WARRANTY_VARIANTS =
    keyof typeof SUPPORTED_WARRANTY_VARIANTS_ENUM
